import React, { Fragment } from "react";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import Wrapper from "../layout/Wrapper";
import { adminRoutes, authRoutes, privateAdminRoutes, privateCustomerRoute } from "../navigation/navigate";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../component/loader/Loader";
import { useCommonContext } from "../context/common";
import PageNotFound from "../pages/notFound/PageNotFound";
import Success from "../pages/payment/Success";
import Cancel from "../pages/payment/Cancel";

const Routing = () => {
  const { isAdmin } = useCommonContext();

  // Reusable RedirectIfLoggedIn component
  const RedirectIfLoggedIn = ({ element }) => {
    const token = localStorage.getItem('authToken');
    const location = useLocation();

    if (!token) {
      return element;
    }
    if (token && authRoutes.some((e) => e.to.includes(location.pathname.split('/')[1])) || location.pathname === '/') {
      return <Navigate to='/dashboard' replace />;
    }
    return element;
  }

  // Reusable RequireAuth component
  const RequireAuth = () => {
    const token = localStorage.getItem('authToken');
    const location = useLocation();
    if (!token) {
      return <Navigate to='/signIn' replace />;
    }

    if (token && authRoutes.some((e) => e.to.includes(location.pathname.split('/')[1])) || location.pathname === '/') {
      return <Navigate to='/dashboard' replace />;
    }
    return <Outlet />;
  }

  return (
    <Fragment>
      <ToastContainer position="top-right" hideProgressBar />
      <Loader />
      <Routes>
        {/* Public Routes */}
        {authRoutes.map((menu) => (
          <Route
            key={menu.to}
            path={menu.to}
            element={<RedirectIfLoggedIn element={menu.element} />}
          />
        ))}

        {/* Protected Routes */}
        <Route element={<RequireAuth />} path="/">
          {isAdmin ? (
            <>
              {adminRoutes.map((menu) => (
                <Fragment key={menu.to}>
                  {menu?.children?.length ? (
                    menu.children.map((child) => (
                      <Route
                        key={child.to}
                        path={child.to}
                        element={<Wrapper>{child.element}</Wrapper>}
                      />
                    ))
                  ) : (
                    <Route key={menu.to} path={menu.to} element={<Wrapper>{menu.element}</Wrapper>} />
                  )}
                </Fragment>
              ))}
              {privateAdminRoutes.map((menu) => (
                <Route
                  key={menu.to}
                  path={menu.to}
                  element={<Wrapper>{menu.element}</Wrapper>}
                />
              ))}
            </>
          ) : (
            <>
              {privateCustomerRoute.map((menu) => (
                <Fragment key={menu.to}>
                  {menu?.children?.length ? (
                    menu.children.map((child) => (
                      <Route
                        key={child.to}
                        path={child.to}
                        element={<Wrapper>{child.element}</Wrapper>}
                      />
                    ))
                  ) : (
                    <Route
                      key={menu.to}
                      path={menu.to}
                      element={<Wrapper>{menu.element}</Wrapper>}
                    />
                  )}
                </Fragment>
              ))}
              <Route path="/payment/success" element={<Wrapper><Success /></Wrapper>} />
              <Route path="/payment/cancel" element={<Wrapper><Cancel /></Wrapper>} />
            </>
          )}
        </Route>

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Fragment>
  );
};

export default Routing;